import React from 'react';

export function Dash() {
  return (
    <span className='c-black-medium f-sm'>&nbsp;-&nbsp;</span>
  );
}
